/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerFindOneQueryResponse, ApplicationSourcesControllerFindOnePathParams, ApplicationSourcesControllerFindOneQueryParams, ApplicationSourcesControllerFindOne400, ApplicationSourcesControllerFindOne401, ApplicationSourcesControllerFindOne403, ApplicationSourcesControllerFindOne404 } from "../../models/checklistsController/ApplicationSourcesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationSourcesControllerFindOne } from "../../clients/checklistsService/applicationSourcesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationSourcesControllerFindOneQueryKey = (id: ApplicationSourcesControllerFindOnePathParams["id"], params: ApplicationSourcesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-application-sources/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ApplicationSourcesControllerFindOneQueryKey = ReturnType<typeof applicationSourcesControllerFindOneQueryKey>;
export function applicationSourcesControllerFindOneQueryOptions(id: ApplicationSourcesControllerFindOnePathParams["id"], params?: ApplicationSourcesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationSourcesControllerFindOneQueryKey(id, params);
  return queryOptions<ApplicationSourcesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindOne400 | ApplicationSourcesControllerFindOne401 | ApplicationSourcesControllerFindOne403 | ApplicationSourcesControllerFindOne404>, ApplicationSourcesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationSourcesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist application source by ID
 * {@link /api/v1/checklist-application-sources/:id}
 */
export function useApplicationSourcesControllerFindOne<TData = ApplicationSourcesControllerFindOneQueryResponse, TQueryData = ApplicationSourcesControllerFindOneQueryResponse, TQueryKey extends QueryKey = ApplicationSourcesControllerFindOneQueryKey>(id: ApplicationSourcesControllerFindOnePathParams["id"], params?: ApplicationSourcesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationSourcesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindOne400 | ApplicationSourcesControllerFindOne401 | ApplicationSourcesControllerFindOne403 | ApplicationSourcesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationSourcesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...applicationSourcesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationSourcesControllerFindOne400 | ApplicationSourcesControllerFindOne401 | ApplicationSourcesControllerFindOne403 | ApplicationSourcesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}